/**
 * グルーピングに必要な最小シェイプ。`BrowseRoomType` はこれを満たす。
 * （_utils を _hooks から独立させるため構造的に型を切る）
 */
type GroupableRoomType = {
  architectureType?: { id: string } | null;
};

export type ArchitectureTypeGroup<T> = {
  /** 建築タイプ id。未設定の部屋タイプは "__none__" にまとめる */
  key: string;
  roomTypes: T[];
};

const NONE_KEY = "__none__";

/**
 * 部屋タイプを建築タイプ単位でグルーピングする。
 * - グループ（建築タイプ）も、グループ内の部屋タイプも、BE が返した順序をそのまま保つ。
 *   部屋タイプの並び「設備が少ない順」は BE (`Site.roomTypesForReservation`) が確定済みで、
 *   FE では並べ替えない (DXPJ-86)。
 */
export function groupRoomTypesByArchitectureType<T extends GroupableRoomType>(
  roomTypes: readonly T[],
): ArchitectureTypeGroup<T>[] {
  const byKey = roomTypes.reduce<Map<string, T[]>>((acc, rt) => {
    const key = rt.architectureType?.id ?? NONE_KEY;
    acc.set(key, [...(acc.get(key) ?? []), rt]);
    return acc;
  }, new Map());

  return [...byKey.entries()].map(([key, roomTypes]) => ({ key, roomTypes }));
}
